import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { RequestNewLog } from '../../../api/log-requests';
import { RequestDeleteSupplier, RequestGetSuppliers } from '../../../api/supplier-requests';
import DataTable from '../../../components/system/DataTable';
import DebugButton from '../../../components/system/DebugButton';
import Loading from '../../../components/system/loading';
import { useAuth } from '../../../context/auth';
import { ENotificationType, useNotifications } from '../../../context/notifications';
import { ELogType, ESeverity } from '../../../interface/log';
import { ISupplier } from '../../../interface/supplier';
import AdminSupplier from './Admin.Supplier';


const AdminSuppliersPge = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [things, setThings] = useState<ISupplier[]>();
    let match = useRouteMatch();
    const { addNotification } = useNotifications()!;
    const { auth } = useAuth()!;


    useEffect(() => {
        window.addEventListener('unload', logOnUnload)
        return () => {
            window.removeEventListener('unload', logOnUnload)
            logOnUnload()
        }
    }, [])
    //log unload page?
    const logOnUnload = async () => {
        return RequestNewLog(undefined, {
            type: ELogType.reactUse,
            requestId: '',
            sessionId: '',
            userId: '',
            payload: '',
            severity: ESeverity.Trivial,
            text: 'react stores onunload'
        });
    }
    // eslint-disable-next-line
    {/*<!-- OPTIONAL 1 -->*/ }


    // eslint-disable-next-line
    {/*<!-- OPTIONAL END -->*/ }



    const mounted = useRef(false);
    useEffect(() => {
        try {
            if (mounted.current === false) {
                mounted.current = true
                // eslint-disable-next-line
                {/*<!-- OPTIONAL 1 -->*/ }
                RequestGetSuppliers(addNotification).then(users => {
                    console.log(users)
                    setThings(users);
                    setLoading(false);
                })

                // eslint-disable-next-line
                {/*<!-- OPTIONAL END -->*/ }
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Suppliers - useEffect', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }

    }, [loading, addNotification]);

    const onDelete = (value: ISupplier) => {
        try {

            const conf = window.confirm("Delete?");
            if (conf) {
                setLoading(true);
                RequestDeleteSupplier(addNotification, value).then(res => {
                    //  console.log(res);
                    let thingsD: ISupplier[] = [];
                    if (things) {
                        thingsD = [...things];
                    }
                    const index = thingsD.findIndex(thing => thing._id === value._id);
                    thingsD.splice(index, 1);

                    setThings(thingsD);
                    setLoading(false);
                    addNotification && addNotification('Success', 'Supplier Deleted!', ENotificationType.Primary);
                });
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Suppliers - onDelete', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }
    }



    return (<>
        {loading === true && <Loading />}
        {things && <div className="col-12">
            <h2>Suppliers Admin</h2>
            <Helmet>
                <title>Suppliers / Admin / {auth.metaData && auth.metaData.SYSTEM_NAME && auth.metaData.SYSTEM_NAME}</title>
            </Helmet>

            <Link className="btn btn-success" to="./suppliers/new">New Supplier <FontAwesomeIcon icon={faPlus} /></Link>
            {/*<!-- OPTIONAL 1 -->*/}



            <DataTable

                colHeadings={[
                    { name: "Name", field: "name", sortable: false },
                    { name: "Mobile", field: "mobile", sortable: false },
                    { name: "Tell", field: "tell", sortable: false },
                    { name: "Email", field: "email", sortable: false },
                    {
                        name: "Actions", field: "id", r: (value: any, index) => {
                            return <div className="btn-group">
                                <DebugButton data={value} />
                                <Link className="btn btn-primary" to={`${match.url}/${value.id}`}>Edit</Link>
                                <button className="btn btn-danger" onClick={(ev: React.MouseEvent) => {
                                    ev.preventDefault();
                                    const conf = window.confirm("Delete?");
                                    if (conf) {
                                        onDelete(value);
                                    }

                                }}>Delete</button>
                            </div>;
                        }, sortable: false
                    },

                ]}

                data={things}
            />

            {/*<!-- OPTIONAL END -->*/}
        </div>}
    </>
    );
};
const AdminSuppliers = () => {
    let match = useRouteMatch();
    return (<>
        <Switch>
            <Route path={`${match.path}/:id`}>
                <AdminSupplier />
            </Route>
            <Route path={`${match.path}`} exact>
                <AdminSuppliersPge />
            </Route>

        </Switch>
    </>
    );
}

export default AdminSuppliers;